import { render, staticRenderFns } from "./LpTag.vue?vue&type=template&id=4f30e084&scoped=true&"
import script from "./LpTag.vue?vue&type=script&lang=js&"
export * from "./LpTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f30e084",
  null
  
)

export default component.exports